import styled from 'styled-components';
import TagTooltipContainer from './TagTooltipContainer';

export default styled(TagTooltipContainer)`
  width: 26rem;
`;
